"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryFlag = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var flagIcons_1 = __importDefault(require("../../../assets/flagIcons"));
var CountryFlag_style_1 = __importDefault(require("./CountryFlag.style"));
/**
 * CountryFlag atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-countryflag--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/CountryFlag Source}
 * {@link https://stories.data.bmw.cloud/?path=/docs/assets-flagicons--bound-story FlagIcons Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/assets/flagIcons.ts FlagIcons Source}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/assets/flags FlagIcons Images}
 */
var CountryFlag = function (_a) {
    var countryCode = _a.countryCode, countryCodeFallback = _a.countryCodeFallback, compact = _a.compact, className = _a.className;
    var classes = (0, CountryFlag_style_1.default)();
    var flagIconFallback = countryCodeFallback && flagIcons_1.default[countryCodeFallback.toLowerCase()];
    var flagIcon = flagIcons_1.default[countryCode.toLowerCase()] || flagIconFallback;
    if (!flagIcon) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)("img", { alt: countryCode, src: flagIcon, className: (0, classnames_1.default)(compact ? classes.rootCompact : classes.root, className) }));
};
exports.CountryFlag = CountryFlag;
